import classNames from 'classnames';
import React from 'react';
interface ADSwitchButtonProps {
  isSaleAD: boolean;
  setisSaleAD: (isSaleAD: boolean) => void;
}
const ADSwitch = ({isSaleAD, setisSaleAD}: ADSwitchButtonProps) => {
  return (
    <div className="flex w-full bg-light-gray p-2 rounded-lg sticky top-0 z-10">
      <button
        className={classNames(
          'w-[50%] gap-4 py-3 flex justify-center items-center rounded-lg',
          {
            'bg-light-green': !isSaleAD,
            'bg-inherit': isSaleAD,
          },
        )}
        onClick={() => setisSaleAD(false)}
      >
        <span className="text-gray-6">آگهی‌های فروش</span>
      </button>
      <button
        className={classNames(
          'w-[50%] gap-4 py-3 flex justify-center items-center rounded-lg',
          {
            'bg-light-green': isSaleAD,
            'bg-inherit': !isSaleAD,
          },
        )}
        onClick={() => setisSaleAD(true)}
      >
        <span className="text-gray-6"> آگهی‌های خرید</span>
      </button>
    </div>
  );
};

export default ADSwitch;
